export default __webpack_public_path__ + "static/media/arrow-down-green.3c548e14.svg";